module.exports = __webpack_public_path__ + "img/champ.b706c82b.jpg";